import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// import { API_URL } from '../../config/config';

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from Redux or storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

// Fetch all devices
export const fetchAllDevices = createAsyncThunk(
  'devices/fetchAllDevices',
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(`${API_URL}/devices/devices`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch devices');
    }
  }
);

// Update device by email (assign device to user by email)
export const updateDevice = createAsyncThunk(
  'devices/updateDevice',
  async ({ deviceData }, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.put(
        `${API_URL}/devices/devices/assign-by-email`,
        deviceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update device');
    }
  }
);

// Delete a device
export const deleteDevice = createAsyncThunk(
  'devices/deleteDevice',
  async (deviceId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.delete(`${API_URL}/devices/deleteDevice/${deviceId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete device');
    }
  }
);

const deviceSlice = createSlice({
  name: 'devices',
  initialState: {
    devices: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearDevices: (state) => {
      state.devices = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDevices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllDevices.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = action.payload;
      })
      .addCase(fetchAllDevices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // update device by email
      .addCase(updateDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDevice.fulfilled, (state, action) => {
        state.loading = false;
        const updatedDevice = action.payload;
        const index = state.devices.findIndex(device => device.device_id === updatedDevice.device_id);
        if (index !== -1) {
          state.devices[index] = { ...state.devices[index], ...updatedDevice };
        }
      })
      .addCase(updateDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete device
      .addCase(deleteDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = state.devices.filter(device => device.device_id !== action.payload.device_id);
      })
      .addCase(deleteDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDevices } = deviceSlice.actions;
export default deviceSlice.reducer;



// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
// // import { API_URL } from '../../config/config';

// const API_URL = process.env.REACT_APP_API_URL;

// // Fetch all devices
// export const fetchAllDevices = createAsyncThunk(
//   'devices/fetchAllDevices',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/devices/devices`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Failed to fetch devices');
//     }
//   }
// );

// // Update device by email (assign device to user by email)
// export const updateDevice = createAsyncThunk(
//   'devices/updateDevice',
//   async ({ deviceData }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(`${API_URL}/devices/devices/assign-by-email`, deviceData);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Failed to update device');
//     }
//   }
// );

// // Delete a device
// export const deleteDevice = createAsyncThunk(
//   'devices/deleteDevice',
//   async (deviceId, { rejectWithValue }) => {
//     try {
//       const response = await axios.delete(`${API_URL}/devices/deleteDevice/${deviceId}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Failed to delete device');
//     }
//   }
// );

// const deviceSlice = createSlice({
//   name: 'devices',
//   initialState: {
//     devices: [],
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     clearDevices: (state) => {
//       state.devices = [];
//       state.error = null;
//       state.loading = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAllDevices.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAllDevices.fulfilled, (state, action) => {
//         state.loading = false;
//         state.devices = action.payload;
//       })
//       .addCase(fetchAllDevices.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // update device by email
//       .addCase(updateDevice.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateDevice.fulfilled, (state, action) => {
//         state.loading = false;
//         const updatedDevice = action.payload;
//         const index = state.devices.findIndex(device => device.device_id === updatedDevice.device_id);
//         if (index !== -1) {
//           state.devices[index] = { ...state.devices[index], ...updatedDevice };
//         }
//       })
//       .addCase(updateDevice.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // Delete device
//       .addCase(deleteDevice.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteDevice.fulfilled, (state, action) => {
//         state.loading = false;
//         state.devices = state.devices.filter(device => device.device_id !== action.payload.device_id);
//       })
//       .addCase(deleteDevice.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearDevices } = deviceSlice.actions;
// export default deviceSlice.reducer;
